module.exports = __webpack_public_path__ + "img/101-j-2.prt.beb00e3a.jpg";